import React, {  useContext, useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Dropdown, Menu, Switch, Card } from 'antd';
import '../Performance Dashboard/PerformanceDashboard.css';
import useApi from '../../hooks/useApi';
import metricApiList from '../../api/PerformanceMetricsApi';
import releaseDetialsApiList from '../../api/ReleaseDetailsApi';
import MetricCard from '../Performance Dashboard/MetricCard';
import { MyContext } from '../../context/myContext';
import moment, { Moment } from 'moment';
import { HiViewColumns } from "react-icons/hi2";
import { DownloadOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import ProductDropdown from '../Performance Dashboard/productsDropdown';
import { getProductList } from '../../utils/DataService';
import { ALL, getStateCategories } from '../Release Comparison/ReleaseComparison';
import { IReleaseItems } from '../../interfaces/IReleaseItems';
import WorkItemsScatterPlot from './WorkItemsScatterPlot';
import { Metric } from '../../interfaces/IMetricChart';
import DropdownSection from '../../utils/DropDownSection';
import { calculateAverage } from '../Performance Dashboard/PerformanceDashboard';
import { PageType } from '../../utils/AppEnum';

type Dataset = {
    set: string;
    value: number;
};


export type WorkItemType = {
    count: number;
    datasets: Dataset[];
    value: number;
    type: string;
};

const getUniqueTypes = (data: any[]) => {
    const types = new Set<string>();

    if (Array.isArray(data)) {
        data.forEach((metric) => {
            if (Array.isArray(metric.data)) {
                metric.data.forEach((item: { work_item_types: any[]; }) => {
                    if (Array.isArray(item.work_item_types)) {
                        item.work_item_types.forEach((workItem: { type: string }) => {
                            if (
                                typeof workItem?.type === "string" &&
                                workItem.type.trim() !== "" &&
                                workItem.type.toLowerCase() !== "null" &&
                                workItem.type.toLowerCase() !== "undefined" &&
                                !Number.isNaN(Number(workItem.type)) === false
                            ) {
                                types.add(workItem.type);
                            }
                        });
                    }
                });
            }
        });
    }
    return Array.from(types);
};


export const parseDurationToDays = (duration: string): number => {
    if (!duration) return 0;
    
    const dayMatch = duration.match(/(\d+)\s+day/);
    const timeMatch = duration.match(/(\d{1,2}):(\d{2}):(\d{2})/);
  
    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
    const hours = timeMatch ? parseInt(timeMatch[1], 10) : 0;
    const minutes = timeMatch ? parseInt(timeMatch[2], 10) : 0;
    const seconds = timeMatch ? parseInt(timeMatch[3], 10) : 0;
  
    const totalDays = days + hours / 24 + minutes / 1440 + seconds / 86400;
    
    return totalDays;
};

const getFilterStorageKey = (product: string) => `workInProgress_${product}`;
const getVisibiltyStorageKey = (product: string) => `workInProgress_metric_summary_visibility_${product}`;

const WorkInProgress: React.FC = () => {
    const getMetricApi = useApi(metricApiList.getMetrics)
    const getReleaseDetailsApi = useApi(releaseDetialsApiList.getReleaseDetails)
    const [performanceMetricsData, setPerformanceMetricsData] = useState<any>([]);
    const [releaseDetails, setReleaseDetails] = useState<IReleaseItems[]>([]);
    const [filteredMetric,setFilteredMetric]=useState<any[]>([])
    
    const { setLoading, setVisibility, visibility, selectedProduct, isTargetEnabled, setIsTargetEnabled,  stateCategories, setStateCategories, selectedStateCategory, setSelectedStateCategory, isCompareTargetVisible, setIsCompareTargetVisible } = useContext<any>(MyContext);
    const [selectedReleases, setSelectedReleases] = useState<string[]>([]);
    const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
    const [selectedEndDate, setSelectedEndDate] = useState<any>(null);
    const [workItemTypes, setWorkItemTypes] = useState<string[]>([]);
    const [selectedType, setSelectedType] = useState<string>(ALL);
    const productList = JSON.parse(getProductList()) || [];
    const [filteredRelease,setFilteredRelease]=useState<any[]>([])
    const [availableReleases, setAvailableReleases] = useState<string[]>([]);
    const hasFetchedFilters = useRef(false);

    const [filters, setFilters] = useState(() => {
        const storedFilters = localStorage.getItem(getFilterStorageKey(selectedProduct));
        return storedFilters
            ? JSON.parse(storedFilters)
            : {
                startDate: selectedStartDate,
                endDate: selectedStartDate,
                releases: selectedReleases,
                workItemType: selectedType,
                analysisA: filteredMetric[0]?.name,
                analysisB: filteredMetric[1]?.name,

            };
    });

    useEffect(() => {
        hasFetchedFilters.current = false;
        
        const storedFilters = localStorage.getItem(getFilterStorageKey(selectedProduct));
        if (storedFilters) {
            setFilters(JSON.parse(storedFilters));
        } else {
            const defaultFilters = {
                startDate: null,
                endDate: null,
                releases: [],
                workItemType: ALL,
                analysisA: filteredMetric[0]?.name,
                analysisB: filteredMetric[1]?.name,

            };
    
            setFilters(defaultFilters);
            setSelectedStartDate(null);
            setSelectedEndDate(null);
            setSelectedReleases([]);
            setSelectedType(ALL);

        }
    }, [selectedProduct]);


    const updateFilter = (key: string, value: any) => {
        const updatedFilters = { ...filters, [key]: value };
        setFilters(updatedFilters);
    };

    const getFiltersFromStorage = () => {
        let storedFilters = JSON.parse(localStorage.getItem(getFilterStorageKey(selectedProduct)) as string);
        if (storedFilters) {
            setSelectedReleases(storedFilters?.releases)
            setSelectedStartDate(storedFilters?.startDate ? dayjs(storedFilters.startDate) : null);
            setSelectedEndDate(storedFilters?.endDate ? dayjs(storedFilters.endDate) : null);
            setSelectedType(storedFilters?.workItemType)
            handleFilterChange(storedFilters?.releases || [], moment(storedFilters?.startDate), moment(storedFilters?.endDate), storedFilters?.workItemType, selectedStateCategory)
            localStorage.setItem(getFilterStorageKey(selectedProduct), JSON.stringify(storedFilters));
        }
    }

    useEffect(() => {
        if (performanceMetricsData && availableReleases.length && !hasFetchedFilters.current) {
            getFiltersFromStorage();
            initializeVisibility(performanceMetricsData);
            hasFetchedFilters.current = true;
        }
    }, [performanceMetricsData, availableReleases]);

    useEffect(() => {
        if (selectedReleases.length > 0) {
            updateMetricDataForSelectedReleases(selectedReleases);
        }
    }, [selectedReleases]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const releaseDetailsResponse = await getReleaseDetailsApi.request(selectedProduct);
                const metricsResponse = await getMetricApi.request(selectedProduct);
                
                const releaseData = releaseDetailsResponse?.data?.release_details;
                setReleaseDetails(releaseData);
                setFilteredRelease(releaseData)
                const categories = extractStageCategories(releaseDetailsResponse?.data);
                setStateCategories(categories);
                const activeReleases: string[] = [];
                if (releaseData) {
                    releaseData.forEach((detail: any) => {
                        if (detail.releases) {
                            detail.releases.forEach((release: any) => {
                                if (release.date === null && release.release) {
                                    activeReleases.push(release.release);
                                }
                            });
                        }
                    });
                }
                const uniqueActiveReleases = Array.from(new Set(activeReleases));
                setAvailableReleases(uniqueActiveReleases);
                
                
                const validMetrics = (metricsResponse?.data?.metrics || []).filter((metric: any) => {
                    const currentRelease = metric.current_release?.[0];
                  
                    if (!currentRelease || !Array.isArray(currentRelease.work_item_types)) return false;
                  
                    return currentRelease.work_item_types.some((type: any) => type.count > 0);
                  });
                  
                  setPerformanceMetricsData(validMetrics);
                  setFilteredMetric(validMetrics);
                  
                  const compareTarget = metricsResponse?.data?.metrics.some(
                    (metric: { target: null; }) => metric.target !== null
                  );
                  setIsCompareTargetVisible(compareTarget);
                  

                setLoading(false);
                hasFetchedFilters.current = false;
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, [selectedProduct]);


    useEffect(() => {
        localStorage.setItem(getFilterStorageKey(selectedProduct), JSON.stringify(filters));
    }, [filters, selectedProduct]);

    const updateMetricDataForSelectedReleases = (selectedReleaseVersions: string[]) => {
        const workItemMap: Map<string, any> = new Map();
        
        if (releaseDetails) {
            releaseDetails.forEach((detail: any) => {
                if (detail.releases) {
                    detail.releases.forEach((release: any) => {
                        if (release.date === null && selectedReleaseVersions.includes(release.release)) {
                            if (release.work_items) {
                                release.work_items.forEach((item: any) => {
                                    if (item.work_item_ID) {
                                        item.release_version = release.release;
                                        workItemMap.set(item.work_item_ID, item);
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
        
        const uniqueFilteredWorkItems = Array.from(workItemMap.values());
        
        const updatedMetrics = performanceMetricsData.map((metric: any) => {
            const workItemsByType = new Map<string, any[]>();
            
            uniqueFilteredWorkItems.forEach((item: any) => {
                const type = item.type || 'Unknown';
                if (!workItemsByType.has(type)) {
                    workItemsByType.set(type, []);
                }
                const typeItems = workItemsByType.get(type);
                if (typeItems) {
                    typeItems.push(item);
                }
            });
            
            const current_release = [];
            
            for (const releaseVersion of selectedReleaseVersions) {
                const releaseWorkItems = uniqueFilteredWorkItems.filter((item: any) => 
                    item.release_version === releaseVersion
                );
                
                const typeGroups = new Map<string, any[]>();
                releaseWorkItems.forEach((item: any) => {
                    const type = item.type || 'Unknown';
                    if (!typeGroups.has(type)) {
                        typeGroups.set(type, []);
                    }
                    const typeItems = typeGroups.get(type);
                    if (typeItems) {
                        typeItems.push(item);
                    }
                });
                
                const work_item_types = [];
                
                const typeEntries = Array.from(typeGroups.entries());
                
                for (const [type, items] of typeEntries) {
                    let value = 0;
                    
                    if (metric.name.toLowerCase().includes('age') || 
                        metric.name.toLowerCase().includes('time') || 
                        metric.name.toLowerCase().includes('duration')) {
                        const totalDuration = items.reduce((sum: number, item: any) => {
                            if (item.execution_time && Array.isArray(item.execution_time)) {
                                return sum + calculateTotalDuration(item.execution_time);
                            }
                            return sum;
                        }, 0);
                        value = items.length ? totalDuration / items.length : 0;
                    } else {
                        value = items.length;
                    }
                    
                    work_item_types.push({
                        type,
                        count: items.length,
                        value,
                        datasets: [{
                            set: type,
                            value
                        }]
                    });
                }
                
                current_release.push({
                    release: releaseVersion,
                    date: null,
                    work_item_types
                });
            }
            
            const data = [...current_release];
            
            return {
                ...metric,
                current_release,
                data
            };
        });
        
        setFilteredMetric(updatedMetrics);
    };

    const calculateTotalDuration = (executionTimeArray: any[]): number => {
        if (!executionTimeArray || executionTimeArray.length === 0) return 0;
      
        let total = 0;
        executionTimeArray.forEach((executionTime: any) => {
            const firstPassDuration = parseDurationToDays(executionTime.first_pass);
            const reworkDuration = parseDurationToDays(executionTime.rework);
            total += firstPassDuration + reworkDuration;
        });
        
        return total;
    };



    const extractStageCategories = (data: any): string[] => {
        let categories: string[] = [];
        
        if (data?.release_details?.state_categories && 
            Array.isArray(data.release_details.state_categories)) {
            categories = data.release_details.state_categories.map(
                (cat: any) => cat.category
            );
        } else if (data?.release_details && 
                 data.release_details[0] && 
                 data.release_details[0].state_categories) {
            const stateCategories = data.release_details[0].state_categories;
            const allCategories = new Set<string>();
            stateCategories.forEach((cat: any) => {
                if (cat.datasets) {
                    cat.datasets.forEach((dataset: any) => {
                        if (dataset.category) {
                            allCategories.add(dataset.category);
                        }
                    });
                }
            });
            categories = Array.from(allCategories);
        }

        return categories;
    };

    const initializeVisibility = (data: Metric[]) => {
        const storedData = localStorage.getItem(getVisibiltyStorageKey(selectedProduct));
        const parsedData = storedData ? JSON.parse(storedData) : null;

        if (parsedData?.visibility?.length) {
            setVisibility(parsedData.visibility);
            setIsTargetEnabled(parsedData.isTargetEnabled ?? true);
        } else {
            const visibilityArray = data.map((metric) => ({
                name: metric.name,
                show: metric.visibility,
            }));

            setVisibility(visibilityArray);
            setIsTargetEnabled(true);

            localStorage.setItem(
                getVisibiltyStorageKey(selectedProduct),
                JSON.stringify({ visibility: visibilityArray, isTargetEnabled: false })
            );
        }
    };

    const toggleVisibility = (name: string | "isTargetEnabled") => {
        if (name === "isTargetEnabled") {
            setIsTargetEnabled((prev: any) => {
                const updatedTargetEnabled = !prev;

                localStorage.setItem(
                    getVisibiltyStorageKey(selectedProduct),
                    JSON.stringify({ visibility, isTargetEnabled: updatedTargetEnabled })
                );

                return updatedTargetEnabled;
            });
        } else {
            setVisibility((prevVisibility: { name: string; show: boolean }[]) => {
                const existingItem = prevVisibility.find((item) => item.name === name);
                let updatedVisibility;

                if (existingItem) {
                    updatedVisibility = prevVisibility.map((item) =>
                        item.name === name ? { ...item, show: !item.show } : item
                    );
                } else {
                    updatedVisibility = [...prevVisibility, { name, show: true }];
                }

                localStorage.setItem(
                    getVisibiltyStorageKey(selectedProduct),
                    JSON.stringify({ visibility: updatedVisibility, isTargetEnabled })
                );

                return updatedVisibility;
            });
        }
    };

    useEffect(() => {
        if (visibility.length === 0) {
            initializeVisibility(performanceMetricsData);
        }
    }, [performanceMetricsData]);

    const handleFilterChange = (selectedReleases: string[], startDate: Moment | null, endDate: Moment | null, selectedType: string, selectedStateCategory: string) => {
        let filteredMetrics = performanceMetricsData;

        setLoading(true);
        
        if (selectedReleases && selectedReleases.length > 0) {
            updateMetricDataForSelectedReleases(selectedReleases);

        } else {
            setFilteredMetric([...performanceMetricsData]);

        }

        if (startDate && startDate?.isValid()) {
            filteredMetrics = filteredMetrics?.map((metric: { data: any[] }) => {
                const filteredData = metric?.data?.filter((data: { date: moment.MomentInput }) => {
                    const metricDate = moment(data.date);
                    if (!metricDate.isValid()) {
                        console.error("Invalid date in metric data:", data.date);
                        return false;
                    }
                    const formattedStartDate = startDate.format('YYYY/MM/DD');
                    const formattedMetricDate = metricDate.format('YYYY/MM/DD');
                    return formattedMetricDate >= formattedStartDate;
                });
                return {
                    ...metric,
                    data: filteredData,
                };
            }).filter((metric: { data: any[] }) => metric.data.length > 0);
        }

        if (endDate && endDate.isValid()) {
            filteredMetrics = filteredMetrics?.map((metric: { data: any[] }) => {
                const filteredData = metric?.data?.filter((data: { date: moment.MomentInput }) => {
                    const metricDate = moment(data.date);
                    if (!metricDate.isValid()) {
                        console.error("Invalid date in metric data:", data.date);
                        return false;
                    }
                    const formattedEndDate = endDate.format('YYYY/MM/DD');
                    const formattedMetricDate = metricDate.format('YYYY/MM/DD');
                    return formattedMetricDate <= formattedEndDate;
                });
                return {
                    ...metric,
                    data: filteredData,
                };
            }).filter((metric: { data: any[] }) => metric.data.length > 0);
        }

        if (selectedType && selectedType !== ALL) {
            filteredMetrics = filteredMetrics
              ?.map((metric: any) => {
                const filteredCurrentRelease = (metric.current_release || [])
                  .map((release: any) => {
                    const filteredWorkItemTypes = (release.work_item_types || []).filter(
                      (w: any) => w.type === selectedType
                    );
          
                    return {
                      ...release,
                      work_item_types: filteredWorkItemTypes,
                    };
                  })
                  .filter((release: any) => release.work_item_types?.length > 0);
          
                const filteredTargets = (metric.target || []).filter(
                  (targetItem: any) => targetItem.work_item_type === selectedType
                );
          
                if (!filteredCurrentRelease.length && !filteredTargets.length) {
                  return null;
                }
          
                const updatedMetric: any = {
                  ...metric,
                  current_release: filteredCurrentRelease,
                };
          
                if (filteredTargets.length > 0) {
                  updatedMetric.target = filteredTargets;
                } else {
                  delete updatedMetric.target;
                }
          
                return updatedMetric;
              })
              .filter(Boolean);
          }

        if (selectedType === ALL) {
            filteredMetrics = filteredMetrics.map((metric: any) => {
                if (!metric.target || metric.target.length === 0) {
                    return metric;
                }

                let totalValue = 0;

                metric.target.forEach((targetItem: any) => {
                    totalValue += targetItem.value;
                });

                const avgValue = totalValue / metric.target.length;
                const unit = metric.target[0]?.units || "";

                return {
                    ...metric,
                    target: [{ work_item_type: ALL, value: avgValue, units: unit }],
                };
            });
        }
        if (selectedStateCategory) {
            filteredMetrics = filteredMetrics?.map((metric: any) => {
              const allStatesExist = stateCategories.every((category: any) =>
                metric.current_release?.some((dataItem: any) =>
                  dataItem.work_item_types?.some((type: any) =>
                    type.datasets?.some((d: any) => d.set === category)
                  )
                )
              );
          
              if (!allStatesExist) {
                return metric;
              }
          
              const filterWorkItemTypesByState = (workItemTypes: any[]) => {
                return workItemTypes
                  ?.map((type: any) => {
                    const datasets = type.datasets || [];
                    const startIndex = datasets.findIndex(
                      (d: any) => d.set?.toLowerCase() === selectedStateCategory.toLowerCase()
                    );
          
                    if (startIndex === -1) return null;
          
                    return {
                      ...type,
                      datasets: datasets.slice(startIndex),
                    };
                  })
                  .filter(Boolean);
              };
          
              const filteredCurrentRelease = metric.current_release
                ? metric.current_release
                    .map((release: any) => ({
                      ...release,
                      work_item_types: filterWorkItemTypesByState(release.work_item_types),
                    }))
                    .filter((release: any) => release.work_item_types?.length > 0)
                : [];
          
              const updatedMetric: any = {
                ...metric,
                current_release: filteredCurrentRelease,
              };
              return filteredCurrentRelease.length > 0 ? updatedMetric : null;
            }).filter(Boolean);
          }

          setFilteredMetric(filteredMetrics);


          let processedReleaseDetails = [...releaseDetails];

          if (selectedType === ALL) {
            const categoryMap: Record<string, { target: number; units: string }> = {};
            const workItemTypes = new Set<string>();
        
            processedReleaseDetails.forEach((item: any) => {
              item.state_categories?.forEach((stateCategory: any) => {
                if (stateCategory.work_item_type) {
                  workItemTypes.add(stateCategory.work_item_type);
                }
        
                stateCategory.datasets.forEach((dataset: any) => {
                  const targetValue = parseFloat(dataset.target);
        
                  if (!isNaN(targetValue)) {
                    if (categoryMap[dataset.category]) {
                      categoryMap[dataset.category].target += targetValue;
                    } else {
                      categoryMap[dataset.category] = {
                        target: targetValue,
                        units: dataset.units,
                      };
                    }
                  }
                });
              });
            });
        
            const workItemTypeCount = workItemTypes.size || 1;
        
            const mergedStateCategories = [
              {
                datasets: Object.entries(categoryMap).map(([category, data]) => ({
                  category,
                  target: data.target / workItemTypeCount,
                  units: data.units,
                })),
              },
            ];
        
            processedReleaseDetails = processedReleaseDetails.map((item: any) => ({
              ...item,
              state_categories: mergedStateCategories,
            }));
          } else if (selectedType && selectedType !== ALL) {
            processedReleaseDetails = processedReleaseDetails.map((item: any) => ({
              ...item,
              releases: item.releases.map((release: any) => ({
                ...release,
                work_items: release.work_items.filter(
                  (workItem: any) => workItem.type === selectedType
                ),
              })),
              state_categories: item.state_categories
                ? item.state_categories.filter(
                    (stateCategory: any) =>
                      stateCategory.work_item_type === selectedType
                  )
                : [],
            }));
          }

          if (selectedStateCategory) {
            const stateCategoriesData = getStateCategories(releaseDetails);
            if (stateCategoriesData.includes(selectedStateCategory)) {
              const startIndex = stateCategoriesData.indexOf(selectedStateCategory);
              const allowedCategories = stateCategoriesData.slice(startIndex);
              
              processedReleaseDetails = processedReleaseDetails.map((item: any) => {
                const filteredStateCategories = item.state_categories?.map((stateCategory: any) => ({
                  ...stateCategory,
                  datasets: stateCategory.datasets?.filter((ds: any) => 
                    allowedCategories.includes(ds.category)
                  )
                }));

                const filteredReleases = item.releases?.map((release: any) => ({
                  ...release,
                  work_items: release.work_items?.map((workItem: any) => ({
                    ...workItem,
                    execution_time: workItem.execution_time?.filter((et: any) => 
                      allowedCategories.includes(et.category)
                    )
                  }))
                }));

                return {
                  ...item,
                  state_categories: filteredStateCategories,
                  releases: filteredReleases
                };
              });
            }
          }

        setFilteredRelease(processedReleaseDetails);

        setLoading(false);

    };



    useEffect(() => {
        if (performanceMetricsData) {
            const uniqueTypes = getUniqueTypes(performanceMetricsData);
            setWorkItemTypes(uniqueTypes);
        } else {
            setWorkItemTypes([]);
        }
    }, [performanceMetricsData]);

    const handleTypeChange = (value: string) => {
        setSelectedType(value);
        handleFilterChange(selectedReleases, selectedStartDate, selectedEndDate, value, selectedStateCategory);
        updateFilter("workItemType", value || null)
    };

    const handleStageChange = (value: string) => {
        setSelectedStateCategory(value);
        handleFilterChange(selectedReleases, selectedStartDate, selectedEndDate, selectedType, value);
    };

    const flattenData = (data: any) => {
        const flattened: any = [];
        data.forEach((metric: any) => {
            const metricName = metric.name;
            const units = metric.units || '';
            metric.data.forEach((release: any) => {
                const releaseName = release.release;
                const releaseDate = release.date;
                const workItemTypes = release.work_item_types || [];

                if (!workItemTypes) {
                    flattened.push({
                        'Release Name': releaseName,
                        'Release Date': releaseDate,
                        'Work Item Type': '',
                        'Metric Name': metricName,
                        'Dataset Name': '',
                        'Metric Value': '',
                        'Metric Units': units,
                    });
                } else {
                    workItemTypes.forEach((workItem: any) => {
                        const workItemType = workItem.type || '';
                        const datasetValue = workItem.value || '';

                        if (!workItem.datasets || workItem.datasets.length === 0) {
                            flattened.push({
                                'Release Name': releaseName,
                                'Release Date': releaseDate,
                                'Work Item Type': workItemType,
                                'Metric Name': metricName,
                                'Dataset Name': workItemType,
                                'Metric Value': datasetValue,
                                'Metric Units': units,
                            });
                        } else {
                            workItem.datasets.forEach((dataset: any) => {
                                const datasetName = dataset.set || '';
                                const datasetValue = dataset.value || '';
                                flattened.push({
                                    'Release Name': releaseName,
                                    'Release Date': releaseDate,
                                    'Work Item Type': workItemType,
                                    'Metric Name': metricName,
                                    'Dataset Name': datasetName,
                                    'Metric Value': datasetValue,
                                    'Metric Units': units,
                                });
                            });
                        }
                    });
                }
            });
        });
        return flattened;
    };
    const convertToCSV = (data: any) => {
        if (!data || !data.length) return "";

        const headers = Object.keys(data[0]).join(",") + "\n";
        const rows = data
            .map((row: any) => Object.values(row).join(","))
            .join("\n");

        return headers + rows;
    };

    const downloadCSV = async () => {
        const data = flattenData(filteredMetric);
        const csv = convertToCSV(data);

        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const fileName = `${selectedProduct}_PerformanceMetrics_${dayjs().format('YYYY_MM_DD')}`
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    return (
        <div className="performance-container">
            <div className="filters">
                <h3 className="card-title mb-2 mt-4 page-heading">
                    Data filters
                </h3>
                {productList?.length > 1 && <div className='mb-2'>
                    <ProductDropdown />
                </div>}

                <DropdownSection
                label="Work Item Type"
                value={selectedType}
                options={["All", ...workItemTypes]}
                onChange={handleTypeChange}
                />

                <DropdownSection
                label="Start from"
                value={selectedStateCategory}
                options={stateCategories}
                onChange={handleStageChange}
                />
            </div>

            <div className="content-area mt-4">
                <h1 className="text-2xl font-semibold text-center pb-4">{`Work In Progress for ${selectedProduct}`}</h1>

                <Card className="shadow-md border rounded-lg">
                    <div className="flex justify-between items-center mt-[-10px]">
                        <h3 className="card-title pb-4">Summary of Work In Progress Metrics</h3>

                        <div className="flex gap-3">
                            <Dropdown
                                overlay={
                                    <Menu className="w-300px">
                                        {isCompareTargetVisible && (
                                            <>
                                                <Row className='ml-3 mt-2'>
                                                    <Col span={15}>
                                                        <div className="dropDownText">Compare with Target</div>
                                                    </Col>
                                                    <Col span={2}>
                                                        <Switch
                                                            checked={isTargetEnabled as boolean}
                                                            className="dropDownIcon scale-75 ml-2"
                                                            onChange={() => toggleVisibility("isTargetEnabled")}
                                                        />
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                        <Menu.Divider />
                                        {filteredMetric
                                        ?.filter((metric: any) =>
                                            metric.data?.some((dataItem: any) =>
                                            dataItem.work_item_types?.some(
                                                (type: any) => Array.isArray(type.datasets) && type.datasets.length > 0
                                            )
                                            )
                                        )
                                        .map((metric: { name: string }, index: any) => {
                                            const isVisible = visibility.find((v: { name: string }) => v.name === metric.name)?.show;
                                            return (
                                                <Menu.Item key={metric.name}>
                                                    <div
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleVisibility(metric.name);
                                                        }}
                                                        className="dropdown-list"
                                                    >
                                                        <span className="dropDownText">{metric.name}</span>
                                                        <span className="dropDownIcon">
                                                            {isVisible ? <EyeOutlined className="ml-8" /> : <EyeInvisibleOutlined className="ml-8" />}
                                                        </span>
                                                    </div>
                                                </Menu.Item>
                                            );
                                        })}
                                    </Menu>
                                }
                                trigger={['click']}
                            >
                                <Button shape="circle" className="action-circle-btn">
                                    <HiViewColumns />
                                </Button>
                            </Dropdown>

                            <Button shape="circle" className="action-circle-btn">
                                <DownloadOutlined onClick={() => downloadCSV()} />
                            </Button>
                        </div>
                    </div>

                    <Row gutter={[16, 16]} className="">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 w-full">
                        {filteredMetric
                        ?.filter((metric: any) =>
                        metric.data?.some((dataItem: any) =>
                        dataItem.work_item_types?.some(
                        (type: any) => Array.isArray(type.datasets) && type.datasets.length > 0
                        )
                        )
                        )
                        .map((metric: {
                            weight: string | null;
                                current_release: any[];
                                is_positive: any; name: string; target: string; units: string; data: any;
                            }) =>
                                visibility.find((v: { name: string }) => v.name === metric.name)?.show && (
                                    <MetricCard
                                        key={metric.name}
                                        name={metric.name}
                                        target={Array.isArray(metric.target) && metric.target.length > 0 ? metric.target[0].value.toString() : null}
                                        units={metric.units}
                                        value={calculateAverage(metric.current_release, metric.weight)}
                                        metric={metric.data}
                                        is_positive={metric.is_positive}
                                        isTargetEnabled={isTargetEnabled}
                                        setSelectedMetricCard={() => {}}
                                        pageType={PageType.WIP_DASHBOARD}
                                    />
                                )
                            )}
                        </div>
                    </Row>
                </Card>

                <Card className="shadow-md border rounded-lg"
                    bodyStyle={{ padding: 0, margin: 0 }}>
                    <div>
                        <WorkItemsScatterPlot 
                            selectedStateCategory={selectedStateCategory} 
                            stateCategories={stateCategories} 
                            selectedReleases={selectedReleases}
                            releaseDetails={filteredRelease}
                            selectedType={selectedType}
                        />
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default WorkInProgress;